
/* injects from baggage-loader */

'use strict';

import pendingToConfirmOfficeTemplate from './pendingToConfirmOffice.html';

/**
* Function that register the all routes for the pendingToConfirmOffice module.
*
* @param {any} $q
* @param {any} $ocLazyLoad
* @param {any} routerHelper
*/
function routeConfig($q, $ocLazyLoad, routerHelper, navigationConstant) {
	'ngInject';

	/**
	* Route definition of the pendingToConfirmOffice page.
	*/
	const indexNav = 6;
	const indexSubmenu = 7;
	const pendingToConfirmOfficeRoute = {
		state: navigationConstant.RESOURCES[indexNav].SUBMENUS[indexSubmenu].STATE,
		config: {
			url: navigationConstant.RESOURCES[indexNav].SUBMENUS[indexSubmenu].URL,
			templateUrl: pendingToConfirmOfficeTemplate,
			controller: 'PendingToConfirmOfficeController',
			controllerAs: 'pendingToConfirmOfficevm',
			resolve: {
				pendingToConfirmOffice: pendingToConfirmOfficeLazyLoading
			},
			data: {
				code: navigationConstant.RESOURCES[indexNav].SUBMENUS[indexSubmenu].CODE,
				login: true,
				pageTitle: navigationConstant.RESOURCES[indexNav].SUBMENUS[indexSubmenu].NAME,
				submenu: true
			},
		}
	}

	routerHelper.configureStates([pendingToConfirmOfficeRoute]);
}

/**
* Function for the lazyLoading configuration in the pendingToConfrim route.
*
* @param {any} $q
* @param {any} $ocLazyLoad
* @returns
*/
function pendingToConfirmOfficeLazyLoading($q, $ocLazyLoad) {
	'ngInject';

	const deferred = $q.defer();

	require.ensure([], require => {
		const pendingToConfirmOfficeModule = require('./pendingToConfirmOffice.module');

		$ocLazyLoad.load({
			name: pendingToConfirmOfficeModule.default.name,
		});

		deferred.resolve(pendingToConfirmOfficeModule.default.controller);
	});

	return deferred.promise;
}

export default angular
	.module('pendingToConfirmOffice.routes', [])
	.run(routeConfig);



// WEBPACK FOOTER //
// ./src/app/auth/components/pendingToConfirmOffice/pendingToConfirmOffice.routes.js